/**
 * Hook that refreshes the hand-aware Pattern Difficulty report whenever
 * the active beatmap / difficulty changes. The actual HTTP call lives in
 * editorStore.refreshPatternDifficulty so the cancellation logic and the
 * arm-span dependency are colocated with the state it owns.
 *
 * Note: arm-span changes are handled directly by setArmSpanMeters, which
 * triggers a refresh when the value moves more than ~1cm.
 */

import { useEffect } from 'react';
import { useEditorStore } from '../store/editorStore';

export function usePatternDifficulty() {
  const beatmapId = useEditorStore(s => s.beatmap?.id);
  const activeDifficulty = useEditorStore(s => s.activeDifficulty);
  const refresh = useEditorStore(s => s.refreshPatternDifficulty);

  useEffect(() => {
    if (!beatmapId) return;
    refresh();
  }, [beatmapId, activeDifficulty, refresh]);
}
